<div
  (focusin)="onFocusIn($event)"
  (focusout)="onFocusOut($event)"
  [formGroup]="form"
  [ngClass]="{ 'prefix--outside': currency === 'outside' || percentage }"
  class="numerical-input__container"
>
  <input
    (input)="_handleInput()"
    [attr.data-input-name]="inputName"
    [ngStyle]="inputStyle"
    [placeholder]="placeholder"
    #input
    [appBlockKeyboard]="
      allowOnlyDecimal ? 'allowOnlyDecimalNumbers' : 'allowOnlyNumbers'
    "
    class="numerical-input__element"
    formControlName="customInput"
  />
</div>
